import {
  FS_PATH_APP_CONFIG,
  FS_PATH_SCENE_CONFIGS,
  FS_PATH_TEAM,
  FS_PATH_TEAM_ALL_MATCHES_MINIMIZED,
  FS_PATH_USER_APP_CONFIGS,
  FS_PATH_FOTBOLL_PLAY_TEAM_CONFIG,
  FS_PATH_MATCHES_MINIMIZED,
  FS_PATH_MATCH,
  FS_PATH_NOTIFICATIONS_LOG,
  FS_PATH_MATCHES_CONFIG,
  FS_PATH_POLL,
  FS_PATH_STORY,
  FS_PATH_FAQ_ARTICLE,
} from '../constants';

export const getTeamDataPath = (abbrv: string) => FS_PATH_TEAM.replace('{abbrv}', abbrv);

export const getAppConfigPath = (abbrv: string) => FS_PATH_APP_CONFIG.replace('{abbrv}', abbrv);

export const getUserAppConfigsPath = (uid: string) =>
  FS_PATH_USER_APP_CONFIGS.replace('{uid}', uid);

export const getSceneConfigPath = (abbrv: string) =>
  FS_PATH_SCENE_CONFIGS.replace('{abbrv}', abbrv);

export const getFotbollPlayTeamConfigPath = (abbrv: string) =>
  FS_PATH_FOTBOLL_PLAY_TEAM_CONFIG.replace('{abbrv}', abbrv);

export const getMatchesConfigPath = (leagueAbbrv: string, season: string) =>
  FS_PATH_MATCHES_CONFIG.replace('{leagueAbbrv}', leagueAbbrv).replace('{season}', season);

export const getMatchesMinimizedPath = (leagueAbbrv: string, season: string) =>
  FS_PATH_MATCHES_MINIMIZED.replace('{leagueAbbrv}', leagueAbbrv).replace('{season}', season);

export const getMatchPath = (leagueAbbrv: string, season: string, matchId: string) =>
  FS_PATH_MATCH.replace('{leagueAbbrv}', leagueAbbrv)
    .replace('{season}', season)
    .replace('{matchId}', matchId);

export const getTeamMatches = (abbrv: string) =>
  FS_PATH_TEAM_ALL_MATCHES_MINIMIZED.replace('{abbrv}', abbrv);

export const getNotificationsLogPath = (type: string, abbrv: string) =>
  FS_PATH_NOTIFICATIONS_LOG.replace('{type}', type).replace('{abbrv}', abbrv);

export const getPollPath = (pollId: string) => FS_PATH_POLL.replace('{id}', pollId);

export const getStoryPath = (storyId: string) => FS_PATH_STORY.replace('{id}', storyId);

export const getFaqArticlePath = (articleId: string) =>
  FS_PATH_FAQ_ARTICLE.replace('{id}', articleId);
